/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import type {
  GetAllIncidentTypesParams,
  IReadOnlyListOfIncidentTypeDto,
  IncidentTypeDto
} from '../models';

import { customInstance } from '../axios';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * @summary Returns all incidenttypes enumeration values, with an optional filter.
 */
export const getAllIncidentTypes = (
    params?: GetAllIncidentTypesParams,
 options?: SecondParameter<typeof customInstance<IReadOnlyListOfIncidentTypeDto>>,) => {
      return customInstance<IReadOnlyListOfIncidentTypeDto>(
      {url: `/incident-management/incident-types`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Returns the IncidentType identified by the route id.
 */
export const getIncidentTypeById = (
    id: number,
 options?: SecondParameter<typeof customInstance<IncidentTypeDto>>,) => {
      return customInstance<IncidentTypeDto>(
      {url: `/incident-management/incident-types/${id}`, method: 'GET'
    },
      options);
    }
  export type GetAllIncidentTypesResult = NonNullable<Awaited<ReturnType<typeof getAllIncidentTypes>>>
export type GetIncidentTypeByIdResult = NonNullable<Awaited<ReturnType<typeof getIncidentTypeById>>>
